import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21')
];

export const server_loads = [];

export const dictionary = {
		"/(sigin-in)": [17],
		"/approve-hotel-review/[id]/[approver]": [18],
		"/(authenticated)/company-news": [4,[2,3]],
		"/(authenticated)/company-news/new": [7,[2,3]],
		"/(authenticated)/company-news/[id]": [5,[2,3]],
		"/(authenticated)/company-news/[id]/edit": [6,[2,3]],
		"/covid-hub": [19],
		"/(authenticated)/credits": [8,[2]],
		"/(authenticated)/dashboard": [9,[2]],
		"/(authenticated)/group-risk": [10,[2]],
		"/(authenticated)/group-risk/[riskId]": [11,[2]],
		"/hotel-review/[id]": [20],
		"/(authenticated)/itinerary/[bookingRef]/[passengerRef]": [12,[2]],
		"/(authenticated)/people": [13,[2]],
		"/(authenticated)/people/[profileId]": [14,[2]],
		"/(authenticated)/risk-hub": [15,[2]],
		"/sso": [21],
		"/(authenticated)/track": [16,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';